import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/lib/i18n';
import '@/lib/sentry';
import { PosthogProvider } from '@/components/providers/posthog';
import { RouterProvider } from '@/components/providers/router';
import { ThemeProvider } from '@/components/providers/theme';
import type { router } from '@/lib/router';

import { QueryProvider } from './components/providers/query';

import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element is not found');
}

if (rootElement.innerHTML) {
  throw new Error('Root element contains some elements');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryProvider>
        <PosthogProvider>
          <RouterProvider />
        </PosthogProvider>
      </QueryProvider>
    </ThemeProvider>
  </React.StrictMode>
);
